import { useMutation, useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import Auth from "../../lib/middleware/auth";
import { ROUTES } from "../../settings/routes";
import { viewUserProfile } from "../actions/authentication";
import {
	fetchCoupleData,
	searchWedding,
	fetchSingleWeddingPhoto,
	fetchUpcomingWeddings,
	enterWeddingEvent,
} from "../actions/wedding";
const coupleLocal = Auth.getCouple();
const experience = Auth.getExperience();

export const useCouplesData = () => {
	const history = useHistory();
	return useQuery("couplesData", fetchCoupleData, {
		enabled: experience === "couple" ? true : false,
		onSuccess: () => {
			if (coupleLocal === undefined && experience === "couple") {
				Toast.fire({
					icon: "error",
					title: `Create a wedding to continue...`,
				});
				return history.push(ROUTES.ACCOUNTSETUP);
			}
		},
	});
};

export const useUserProfileData = () => {
	return useQuery("userData", viewUserProfile, {
		refetchOnWindowFocus: false,
		refetchOnmount: true,
	});
};

export const useSearchWedding = ({ searchQuery, location, search }) => {
	const history = useHistory();
	return useQuery(
		["SearchWedding", searchQuery],
		() =>
			searchWedding({
				searchQuery,
			}),
		{
			enabled: !isEmpty(searchQuery) && search,
			refetchOnWindowFocus: false,
			onSuccess: (search) => {
				const { hasError } = search;
				const handleSearch = () => {
					Toast.fire({
						icon: !hasError ? "success" : "error",
						title: search.message,
					});
				};
				location.pathname !== "/search"
					? history.push({
							pathname: ROUTES.SEARCH,
							state: {
								routeData: search.data,
								searchQuery: searchQuery,
							},
					  })
					: handleSearch();
			},
			onError: (err) => {
				Toast.fire({
					icon: "success",
					title: err.response.data.message,
				});
			},
		}
	);
};

export const useViewSingleWeddingPhoto = ({
	weddingId,
	albumId,
	eventCode,
}) => {
	return useQuery(
		["SingleWeddingPhotos", { weddingId, albumId, eventCode }],
		() => fetchSingleWeddingPhoto({ weddingId, albumId, eventCode }),
		{
			refetchOnWindowFocus: false,
		}
	);
};

export const useFetchUpcomingWeddings = () => {
	return useQuery("upcomingWeddings", fetchUpcomingWeddings, {
		refetchOnWindowFocus: false,
	});
};

export const useEnterWedding = () => {
	return useMutation(enterWeddingEvent);
};
